export default function(base, opts) {
  const keys = Object.keys(opts);
  for (let i = 0; i < keys.length; ++i) {
    base[keys[i]] = opts[keys[i]];
  }
  return base;
}
